/**
 * Specific dashlet for table dialogs (i.e. dialogs with only tables)
 */
hrd.AbstractTablePopup = hrd.AbstractTableDashlet.extend({
	init: function(panel, options) {
		var size = dashboardInstance.isDoubleSize() ? '2x' : '1x';
		var defaults = {
			impl: 'hrd.AbstractTablePopup',
			size: size,
			dialog: undefined
		};
		this._super(panel, $.extend({}, defaults, options));
	},
	getDialog: function() {
		return this.settings.dialog;
	},
	closeDialog: function() {
		if (this.settings.dialog) {
			this.settings.dialog.dialog('close');
		}
	},
	getProceedButton: function() {
		return $('.ok-button', this.settings.dialog.closest('.ui-dialog'));
	},
	toggleProceedButton: function(enable) {
		enable = (enable == undefined) ? true : enable;
		var $pb = this.getProceedButton();
		$pb.button('option', 'disabled', !enable);
	},
	executeProceedButton: function() {
		var $pb = this.getProceedButton();
		$pb.trigger('click');
	},
	getButtonByAction: function(action) {
		return $('.' + action, this.settings.dialog.closest('.ui-dialog'));
	},
	toggleButtonByAction: function(action, enable) {
		enable = (enable == undefined) ? true : enable;
		var $pb = this.getButtonByAction(action);
		$pb.button('option', 'disabled', !enable);
	},
	executeButtonByAction: function(action) {
		var $pb = this.getButtonByAction(action);
		$pb.trigger('click');
	}
});